import { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtTime } from "../lib/format";
import { ScrollText } from "lucide-react";

const SEV = {
  INFO: "#3B82F6",
  WARN: "#F59E0B",
  ERROR: "#EF4444",
  CRITICAL: "#DC2626",
};

export default function LogsView() {
  const [rows, setRows] = useState([]);
  const [sev, setSev] = useState("");

  const load = () => {
    const params = {};
    if (sev) params.severity = sev;
    api.get("/events", { params }).then((r) => setRows(r.data)).catch(() => {});
  };
  useEffect(() => { load(); const i = setInterval(load, 8000); return () => clearInterval(i); /* eslint-disable-next-line */ }, [sev]);

  return (
    <div className="space-y-4 fade-up">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h2 className="font-head text-xl font-bold flex items-center gap-2">
          <ScrollText className="h-5 w-5 text-[#3B82F6]" /> Olay Günlüğü
        </h2>
        <div className="flex gap-2">
          {["", "INFO", "WARN", "ERROR", "CRITICAL"].map((x) => (
            <button
              key={x || "all"}
              onClick={() => setSev(x)}
              className={`text-xs font-semibold rounded-md px-3 py-1.5 border transition-colors ${sev === x ? "bg-[#3B82F6]/20 border-[#3B82F6]/50 text-[#3B82F6]" : "border-[#2A364F] text-[#64748B] hover:text-[#94A3B8]"}`}
            >
              {x || "TÜMÜ"}
            </button>
          ))}
        </div>
      </div>

      <div data-testid="event-log-container" className="bg-[#0B0E17] border border-[#1E2738] rounded-lg p-4 font-mono text-xs space-y-1.5 max-h-[70vh] overflow-y-auto">
        {rows.length === 0 && <div className="text-[#64748B] py-6 text-center">Kayıt yok.</div>}
        {rows.map((e, i) => (
          <div key={i} className="flex items-start gap-3 py-1 border-b border-[#1E2738]/40">
            <span className="text-[#64748B] whitespace-nowrap">{fmtTime(e.ts)}</span>
            <span className="font-bold whitespace-nowrap" style={{ color: SEV[e.severity] || "#94A3B8" }}>[{e.severity}]</span>
            <span className="text-[#64748B] whitespace-nowrap">{e.category}</span>
            <span className="text-[#F1F5F9]">{e.message}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
